import { Component, OnInit } from "@angular/core";

@Component({
  selector: "app-auth-navbar",
  templateUrl: "./auth-navbar.component.html",
})
export class AuthNavbarComponent implements OnInit {
  navbarOpen = false;
  isDropdownOpen = false;

  constructor() {}

  ngOnInit(): void {}


  toggleDropdown() {
    this.isDropdownOpen = !this.isDropdownOpen;
  }

  setNavbarOpen() {
    this.navbarOpen = !this.navbarOpen;
  }
}
